import { LocalGroceryStore } from "@mui/icons-material";

import { Typography } from "@mui/material";
import { useState } from "react";

import CommonButton from "../utils/CommonButton";
import LazoModal from "../utils/LazoModal";
import StripeDiscountsView from "./StripeDiscountsView";

//TODO:Move this to a sepparate file, this is a component
export default function StripeDiscountModal() {
  const [openModal, setOpenModal] = useState<boolean>(false);

  function toggleForm() {
    setOpenModal((prev) => !prev);
  }

  return (
    <>
      <CommonButton
        sx={{
          height: "2.5rem",
          whiteSpace: "nowrap",
          paddingInline: "1rem",
          borderRadius: "0.5rem",
        }}
        endIcon={<LocalGroceryStore />}
        onClick={toggleForm}
      >
        <Typography fontWeight={600}>Promotion Codes</Typography>
      </CommonButton>
      {openModal && (
        <LazoModal open={openModal} handleClose={toggleForm} title="Promotion Codes" titleSxProps={{ fontWeight: "600" }}>
          <StripeDiscountsView />
        </LazoModal>
      )}
    </>
  );
}
